<template>
  <div class="flex items-center gap-2">
    <span>
      <slot name="icon" />
    </span>
    <slot />
  </div>
</template>
